import React from 'react';
import { DescriptionColumn } from './description-column';
import { ProviderColumn } from './provider-column';
import { Row } from './row';

export const TotalPaymentDueRow = ({ providers, periodLabel, totalPaymentDueProviderValues }) => (
  <Row paddingBottom={'10px'}>
    <DescriptionColumn fontSize={16} isBold={true}>
      Total payment due for {periodLabel}
    </DescriptionColumn>
    {providers.map((provider) => {
      const value = totalPaymentDueProviderValues.find((values) => values.providerID === provider.id)?.value || '';
      return (
        <ProviderColumn key={`tableReceipts_${provider.id}`} isBold={true}>
          {value}
        </ProviderColumn>
      );
    })}
  </Row>
);
